// extracted by mini-css-extract-plugin
export default {"wrapper":"Terminations_wrapper__p0+x0","wrapper__content":"Terminations_wrapper__content__nHaJS","wrapper__content__left":"Terminations_wrapper__content__left__kosmu"};